import { ClientHelper } from '../client/CreateNswagClient';

export const buildFilesUploadUrl = (params: {
  endpoint: 'upload-only' | 'upload';
  subfolder: string | null;
  assistantInternalName?: string | null;
}) => {
  const baseUrl = (process.env.REACT_APP_API_BASE ?? '').replace(/\/+$/, '');
  if (!baseUrl) {
    throw new Error('API-Basis-URL fehlt.');
  }
  const cleanSubfolder = (params.subfolder ?? '').replace(/^\/+|\/+$/g, '');
  const basePath = cleanSubfolder
    ? `${baseUrl}/files/${params.endpoint}/${encodeURIComponent(cleanSubfolder)}`
    : `${baseUrl}/files/${params.endpoint}`;
  if (!params.assistantInternalName) {
    return basePath;
  }
  return `${basePath}?assistant=${encodeURIComponent(params.assistantInternalName)}`;
};

export const postFilesFormData = async (url: string, files: File[], token: string) => {
  const filesClient = ClientHelper.createFilesClient(token) as any;
  const instance = filesClient?.instance;
  if (!instance) {
    throw new Error('Upload fehlgeschlagen: FilesClient instance fehlt.');
  }
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file, file.name));
  if (files.length === 1) {
    const [single] = files;
    formData.append('fileName', single.name);
  }
  const response = await instance.request({
    method: 'POST',
    url,
    data: formData,
    headers: {
      Accept: 'application/json',
    },
  });
  if (response.status !== 200 && response.status !== 204) {
    throw new Error(typeof response.data === 'string' ? response.data : 'Upload fehlgeschlagen');
  }
  return response.data;
};
